import { request as myRequest } from '@/shared/io';
export var REQUEST_API;
(function (REQUEST_API) {
    REQUEST_API["DICT_QUERY"] = "/api/uims/v1/dict/query";
    REQUEST_API["DICT_QUERY_BY_TYPES"] = "/api/uims/v1/dict/query-by-types";
})(REQUEST_API || (REQUEST_API = {}));
const _isString = (data) => typeof data === 'string';
const _isArray = (data) => Array.isArray(data);
/**
 * 获取字典Code请求
 *
 * @param data 传递给后端的参数。也可以直接传递键值获取一级的所有信息
 * @param options 其他选项
 */
export const dictQueryCode = (data, options) => {
    return new Promise((resolve, reject) => {
        const isString = _isString(data);
        const url = isString
            ? REQUEST_API.DICT_QUERY
            : _isArray(data?.types)
                ? REQUEST_API.DICT_QUERY_BY_TYPES
                : REQUEST_API.DICT_QUERY;
        const isTypes = !isString && _isArray(data?.types);
        myRequest(url, {
            ...options,
            data: {
                dataType: 2,
                status: 1,
                queryType: isString ? 1 : data?.parentId ? 3 : 1,
                ...(isString ? { type: data } : data),
            },
            method: 'post',
        })
            .then((res) => {
            res = res?.data;
            if (!isTypes && (!res || Object.keys(res).length <= 0)) {
                resolve([]);
            }
            resolve(res);
        })
            .catch(() => {
            resolve((isTypes ? {} : []));
        });
    });
};
/**
 * 替换原来的请求接口，该方法直接返回data数据的字典请求
 *
 * @param url 请求的url
 * @param options 选项
 * @param params 其他参数，暂时无用
 */
export const handleDictRequest = (url, options, ...params) => {
    return new Promise((resolve, reject) => {
        const [query, type] = url.split('/').slice(-2);
        const isTypes = query == 'codes';
        const _params = {
            ...options,
            data: {
                dataType: 2,
                queryType: options?.data?.parentId ? 3 : 1,
                status: 1,
                ...(isTypes ? { types: type.split(',') } : { type }),
                ...options?.data,
            },
            method: 'post',
        };
        myRequest(isTypes ? REQUEST_API.DICT_QUERY_BY_TYPES : REQUEST_API.DICT_QUERY, _params)
            .then((res) => {
            res = res?.data;
            if (!isTypes && (!res || Object.keys(res).length <= 0)) {
                resolve([]);
            }
            resolve(res);
        })
            .catch(() => {
            resolve((isTypes ? {} : []));
        });
    });
};
/**
 * 替换原来的请求接口，该方法直接返回 { code,data } 数据的字典请求
 *
 * @param url 请求的url
 * @param options 选项
 * @param params 其他参数，暂时无用
 */
export const handleDictObjRequest = (url, options, ...params) => {
    return new Promise((resolve, reject) => {
        const [query, type] = url.split('/').slice(-2);
        const isTypes = query == 'codes';
        const _params = {
            ...options,
            data: {
                dataType: 2,
                queryType: options?.data?.parentId ? 3 : 1,
                status: 1,
                ...(isTypes ? { types: type.split(',') } : { type }),
                ...options?.data,
            },
            method: 'post',
        };
        myRequest(isTypes ? REQUEST_API.DICT_QUERY_BY_TYPES : REQUEST_API.DICT_QUERY, _params)
            .then((res) => {
            res = res?.data;
            if (!isTypes && (!res || Object.keys(res).length <= 0)) {
                resolve({
                    code: 200,
                    data: [],
                });
            }
            resolve({
                code: 200,
                data: res,
            });
        })
            .catch(() => {
            resolve({
                code: 200,
                data: (isTypes ? {} : []),
            });
        });
    });
};
